import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TREQUEST_TENANT_APPS } from '@monorepo/types';
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'activation-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent {
  @Input() errorMsg = '';
  @Output() submitedToken = new EventEmitter();
  tokenPostData: TREQUEST_TENANT_APPS = {
    token: '',
  };
  isSubmitting = false;

  public printError = '';

  ngOnChanges() {
    if (this.errorMsg) {
      this.printError =
        'Activation failed. Please check whether you have entered correct token or contact you system administrator';
    }
  }

  public handleSubmit() {
    console.log('POST TOKEN ', this.tokenPostData);
    this.submitedToken.emit({ ...this.tokenPostData });
  }
}
